/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ServerSettingsDialogFormStore } from '../server-settings-dialog-form-store';

export const ServerSettingsDialogFormStoreContext = createContext<ServerSettingsDialogFormStore>({} as ServerSettingsDialogFormStore);
